<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-title>{{ t('UserProfilePage.myPosts') }}</ion-title>
        <ion-buttons slot="start">
          <ion-back-button default-href="/profile"></ion-back-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content :fullscreen="true">
      <!-- Loading Data -->
      <div class="spin" v-if="loading">
        <ion-spinner></ion-spinner>
      </div>

      <!-- Data loaded -->
      <ion-grid fixed v-else>
        <ion-list>
          <post-item v-for="post in posts" :key="post.id" :post="post" :extraRouterParams="{ parentPath: '/my-posts' }"></post-item>
        </ion-list>
      </ion-grid>
    </ion-content>
  </ion-page>
</template>

<script lang="ts">
// Vue reactivity
import { computed } from 'vue';

// icons
import { thumbsUpOutline, thumbsDownOutline } from 'ionicons/icons';

// components
import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent,
        IonSpinner, IonList, IonButtons, IonBackButton, } from '@ionic/vue';

import PostItem from "@/components/PostItem.vue";

import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';

export default {
  name: 'UserPostListPage',
  components: { IonPage, IonHeader, IonToolbar, IonTitle, IonContent,
                IonSpinner, IonList, IonButtons, IonBackButton, PostItem, },
  setup() {
    const store = useStore();

    // 1. declare state variables (ref to make them reactive)
    const loading = computed(() => store.state.loadingPosts);
    const posts = computed(() => store.getters.userPosts);

    // methods or filters
    const { t } = useI18n();

    // 3. return variables & methods to be used in template HTML
    return {
      t,
      
      // icons
      thumbsUpOutline, thumbsDownOutline,

      // variables
      loading, posts,
    }
  }
}
</script>